import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TreePersonCard } from '@/components/person/TreePersonCard';
import { useHybridPedigreeStore } from '@/hooks/useStores';

interface RootGenerationProps {
  onTreeViewClick?: (familyMemberId: string) => void;
  onProfileClick?: (familyMemberId: string) => void;
  onAddClick?: (familyMemberId: string, option: 'child' | 'spouse' | 'parent' | 'pet') => void;
  canAddByMemberId?: Record<string, boolean>;
}

const RootGeneration: React.FC<RootGenerationProps> = observer(
  ({ onTreeViewClick, onProfileClick, onAddClick, canAddByMemberId = {} }) => {
    const { t } = useTranslation('pedigree');
    const hybridPedigreeStore = useHybridPedigreeStore();
    const { treeAnchorFamilyMemberId } = hybridPedigreeStore;
    const { leftRootFamilyMemberId, rightRootFamilyMemberId } = hybridPedigreeStore.rootGen;

    // Show root generation if at least one person exists (tree anchor should always be present)
    if (!leftRootFamilyMemberId && !rightRootFamilyMemberId) {
      return null;
    }

    return (
      <div className="generation generation-root">
        <span className="generation-label" aria-hidden>
          {t('generations.anchor')}
        </span>
        <div className="partnership">
          {leftRootFamilyMemberId && (
            <TreePersonCard
              familyMemberId={leftRootFamilyMemberId}
              generation={0}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[leftRootFamilyMemberId] ?? false}
              partnerFamilyMemberId={rightRootFamilyMemberId ?? undefined}
              canAddByMemberId={canAddByMemberId}
              isTreeAnchor={treeAnchorFamilyMemberId === leftRootFamilyMemberId}
            />
          )}
          {rightRootFamilyMemberId && (
            <TreePersonCard
              familyMemberId={rightRootFamilyMemberId}
              generation={0}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[rightRootFamilyMemberId] ?? false}
              partnerFamilyMemberId={leftRootFamilyMemberId ?? undefined}
              canAddByMemberId={canAddByMemberId}
              isTreeAnchor={treeAnchorFamilyMemberId === rightRootFamilyMemberId}
            />
          )}
        </div>
      </div>
    );
  }
);

export default RootGeneration;
